import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_moa_content_splash = _resolveComponent("moa-content-splash")!
  const _component_moa_content_timeline = _resolveComponent("moa-content-timeline")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'hd-moa-content',
			{ 'is-inside-cell': _ctx.insideCell },
			`hd-moa-content__${_ctx.screen}`,
		])
  }, [
    (_ctx.screen === 'splash')
      ? (_openBlock(), _createBlock(_component_moa_content_splash, { key: 0 }))
      : (_openBlock(), _createBlock(_component_moa_content_timeline, { key: 1 }))
  ], 2))
}